import { render } from "./industry-data.vue?vue&type=template&id=3333ec4c&scoped=true"
import script from "./industry-data.vue?vue&type=script&lang=js"
export * from "./industry-data.vue?vue&type=script&lang=js"

import "./industry-data.vue?vue&type=style&index=0&id=3333ec4c&lang=scss&scoped=true"

import exportComponent from "/Users/admin/Codes/d86e-client-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3333ec4c"]])

export default __exports__